import { subscriptionsApi } from '@features/subscriptions/store/api';
import { enhancedApi as assistantApi } from '@store/generated/assistant';

// Enhance the API with cache tags for custom prompts
export const documentsApi = assistantApi.enhanceEndpoints({
  addTagTypes: ['CustomPrompts'],
  endpoints: {
    getV2ProviderDocumentsPrompts: {
      providesTags: ['CustomPrompts'],
    },
    postV2ProviderDocumentsPrompts: {
      invalidatesTags: ['CustomPrompts'],
    },
    deleteV2ProviderDocumentsPromptsByPromptId: {
      invalidatesTags: ['CustomPrompts'],
    },
    postV2ProviderDocumentsEdit: {
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Invalidate Entitlements to refresh entitlement usage
          dispatch(subscriptionsApi.util.invalidateTags(['Entitlements']));
        } catch {
          // Error handled by mutation hook
        }
      },
    },
  },
});

// Export document edit hooks
export const {
  usePostV2ProviderDocumentsEditMutation,
  usePostV2ProviderDocumentsResumeMutation,
  usePostV2ProviderDocumentsGeneratePdfMutation,
  usePostV2ProviderDocumentsPromptsExtractMutation,
  useGetV2ProviderDocumentsPromptsExtractByTaskIdQuery,
  useLazyGetV2ProviderDocumentsPromptsExtractByTaskIdQuery,
  usePostV2ProviderDocumentsPromptsMutation,
  useGetV2ProviderDocumentsPromptsQuery,
  useDeleteV2ProviderDocumentsPromptsByPromptIdMutation,
} = documentsApi;

// Re-export types we need
export type {
  DocumentEditRequest,
  DocumentEditResponse,
  DocumentResumeRequest,
  GeneratePdfRequest,
  GeneratePdfResponse,
  CustomPromptResponse,
  ExtractDocumentPromptRequest,
  ExtractDocumentPromptResponse,
  ExtractPromptTaskResponse,
  ExtractPromptStatusResponse,
  SaveCustomPromptRequest,
  ListCustomPromptsResponse,
  DeletePromptResponse,
} from '@store/generated/assistant';
